import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class FeatureGridComponent implements Component {

    private $root:JQuery;
    private $toToggle:JQuery;
    private $toggle:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$toToggle = this.$root.find('.js-feature-grid-overlay-toggleable');
        this.$toggle = this.$root.find('.js-feature-grid-overlay-toggle');
    }

    init() {
        this.$root.on('click', this.handleOverlayToggle);
    }

    private handleOverlayToggle = (ev:Event) => {
        this.$toggle.toggleClass('show-overlay').toggleClass('hide-text');
        this.$toToggle.toggleClass('hide-text');
        this.$root.toggleClass('has-content-overlay');
    }
}